import React, { useState, useEffect } from "react";
import { ArrowRight } from "lucide-react";
import { useNavigate } from "react-router-dom";
import api from "../../../configs/api";
import HomePropertyCard from "../userCommon/HomePropertyCard";
import fallback from "../../../assets-user/home/advertisement_1.png";
import ComingSoonCard from "../userCommon/ComingSoonCard";
import { useAppContext } from "../../../context/AppContext";

const CommercialPropertySection = () => {
  const [loading, setLoading] = useState(true);
  const [properties, setProperties] = useState([]);
  const navigate = useNavigate();
  const { ads, adsLoading } = useAppContext();

  useEffect(() => {
    const fetchCommercialProperties = async () => {
      try {
        setLoading(true);
        const res = await api.get("/properties/home?type=commercial");
        setProperties(res.data?.data?.slice(0, 4) || []);
      } catch (err) {
        console.error("Error fetching commercial:", err);
        setProperties([]);
      } finally {
        setLoading(false);
      }
    };

    fetchCommercialProperties();
  }, []);

  return (
    <div className="flex items-center">
      <div className="w-full px-4 sm:px-6 md:px-8 lg:px-10  bg-white pb-6 md:pb-8 lg:pb-10">
        {/* Header */}
        <div className="flex justify-between items-center pb-6 md:pb-8 lg:pb-10">
          <h2 className="font-medium text-[#031722] text-lg sm:text-xl md:text-2xl">
            Commercial Properties
          </h2>

          <button
            onClick={() => {
              navigate("/properties");
              window.scrollTo(0, 0);
            }}
            className="flex items-center gap-1 sm:gap-2 text-red-600 font-medium text-xs sm:text-base"
          >
            View all <ArrowRight className="w-3 sm:w-4 h-3 sm:h-4" />
          </button>
        </div>

        <div className="flex flex-col md:flex-row gap-4 ">
          <div className="flex-1 flex gap-4 overflow-x-auto scrollbar-none snap-x snap-mandatory xl:grid xl:grid-cols-4 xl:overflow-x-visible xl:snap-none">
            {!loading &&
              properties?.map((property, i) => (
                <div
                  key={property?._id || i}
                  className="snap-start shrink-0 w-[75%] sm:w-[50%]  xl:w-auto xl:max-w-sm"
                >
                  <HomePropertyCard property={property} />
                </div>
              ))}

            {/* Skeleton loaders while loading */}
            {loading &&
              Array.from({ length: 4 }).map((_, i) => (
                <div
                  key={"skeleton-" + i}
                  className="snap-start shrink-0 w-[75%] sm:w-[50%] md:w-[33%] xl:w-auto xl:max-w-sm"
                >
                  <SkeletonCard />
                </div>
              ))}

            {/* Coming Soon fillers if less than 5 after load */}
            {!loading &&
              properties.length < 4 &&
              Array.from({ length: 4 - properties.length }).map((_, i) => (
                <div
                  key={"coming-" + i}
                  className="snap-start shrink-0 w-[75%] sm:w-[50%] md:w-[33%] xl:w-auto xl:max-w-sm"
                >
                  <ComingSoonCard />
                </div>
              ))}
          </div>
          <div className="flex w-full items-center justify-center shrink-0 bg-white  md:w-[30%] lg:w-[28%] xl:w-fit xl:max-w-sm sm:sticky sm:top-24 sm:self-center">
            <AdvertisementCard
              ads={ads}
              fallback={fallback}
              adsLoading={adsLoading}
            />
          </div>
        </div>
      </div>
    </div>
  );
};

export default CommercialPropertySection;

const SkeletonCard = () => (
  <div className="bg-white rounded-xl border border-gray-200 shadow-sm">
    <div className="h-48 sm:h-52 bg-gray-200 animate-pulse rounded-t-xl"></div>

    <div className="p-3 space-y-3">
      <div className="h-5 bg-gray-300 rounded w-3/4"></div>
      <div className="h-4 bg-gray-200 rounded w-full"></div>

      <div className="flex justify-between items-center pt-2">
        <div className="h-4 bg-gray-200 rounded w-20"></div>
        <div className="h-4 bg-gray-200 rounded w-16"></div>
      </div>
    </div>
  </div>
);

const AdvertisementCard = ({ ads, fallback, adsLoading }) => {
  return (
    <div className="bg-white rounded-xl border border-gray-200 shadow-sm aspect-square lg:aspect-auto">
      <div className="h-auto md:h-[19.7rem] overflow-hidden rounded-xl">

        {adsLoading ? (
          <div className="w-full h-full animate-pulse bg-gray-200 rounded-xl" />
        ) : (
          <img
            src={ads?.topAdUrl || fallback}
            alt="advertisement"
            className="w-full h-full object-cover"
          />
        )}

      </div>
    </div>
  );
};


// import React, { useState, useEffect } from "react";
// import { CheckCircle, Heart, ArrowRight, Clock } from "lucide-react";
// import homeImg from "../../../assets-user/home.png";
// import img from "../../../assets-user/happy.png";
// import propertyLogo from "../../../assets-user/property.svg";
// import { useNavigate } from "react-router-dom";
// import api from "../../../configs/api";
// import { formatPrice } from "../../../utils/helpers";
// import { timeAgo } from "../../../utils/helpers";

// const CommercialPropertySection = () => {
//   const [loading, setLoading] = useState(true);
//   const [properties, setProperties] = useState([]);
//   const navigate = useNavigate();

//   const truncateText = (text, limit) => {
//     if (!text) return "";
//     return text.length > limit ? text.slice(0, limit) + "..." : text;
//   };

//   useEffect(() => {
//     const fetchCommercialProperties = async () => {
//       try {
//         setLoading(true);
//         const response = await api.get("/properties?type=commercial");

//         // Limit to maximum 3 properties
//         const limitedProperties = response.data.data.slice(0, 3);
//         setProperties(limitedProperties);
//       } catch (error) {
//         console.error("Error fetching commercial properties:", error);
//         setProperties([]);
//       } finally {
//         setLoading(false);
//       }
//     };

//     fetchCommercialProperties();
//   }, []);

//   // Coming Soon
//   const getComingSoonCount = () => {
//     if (loading) return 0;
//     const propertyCount = properties.length;
//     if (propertyCount === 1) return 2;
//     if (propertyCount === 2) return 1;
//     return 0;
//   };

//   const comingSoonCount = getComingSoonCount();

//   // Render Coming Soon Card
//   const renderComingSoonCard = (index) => (
//     <div
//       key={`coming-soon-${index}`}
//       data-aos="zoom-in-up"
//       data-aos-delay={(properties.length + index) * 150}
//       className="bg-gradient-to-br from-gray-50 to-gray-100 rounded-xl shadow-md flex-shrink-0 w-[80%] md:w-[70%] lg:w-auto snap-start border-2 border-dashed border-gray-300 mb-4"
//     >
//       {/* Image Section with Coming Soon Message */}
//       <div className="relative h-48 sm:h-60 bg-gradient-to-br from-gray-200 to-gray-300 rounded-lg flex items-center justify-center">
//         <div className="text-center">
//           <Clock className="w-12 h-12 text-gray-400 mx-auto mb-3 animate-pulse" />
//           <p className="text-gray-600 font-semibold text-lg">Coming Soon</p>
//           <p className="text-gray-500 text-sm mt-1">New properties arriving</p>
//         </div>
//       </div>

//       {/* Property Details Placeholder */}
//       <div className="p-4">
//         <div className="space-y-2">
//           <div className="h-5 bg-gray-300 rounded w-3/4 animate-pulse"></div>
//           <div className="h-4 bg-gray-200 rounded w-full animate-pulse"></div>
//           <div className="h-4 bg-gray-200 rounded w-full animate-pulse mt-1"></div>
//           <div className="flex justify-between mt-3">
//             <div className="h-3 bg-gray-300 rounded w-1/2 animate-pulse"></div>
//             <div className="h-3 bg-gray-300 rounded w-1/4 animate-pulse"></div>
//           </div>
//         </div>
//       </div>
//     </div>
//   );

//   // Smooth scroll helper
//   const scrollToTop = () => {
//     window.scrollTo({
//       top: 0,
//       behavior: "smooth",
//     });
//   };

//   return (
//     <div className="px-4 sm:px-6 md:px-8 lg:px-10 bg-white">
//       {/* Header Section */}
//       <div className="flex justify-between items-center pb-4 md:pb-6 lg:pb-8">
//         <h2 className="font-medium text-[#031722] text-lg sm:text-xl md:text-2xl ">
//           Commercial Property{" "}
//         </h2>

//         <button
//           onClick={() => {
//             navigate("/properties");
//             window.scrollTo(0, 0);
//           }}
//           className="flex items-center gap-1 sm:gap-2 text-red-600 font-medium text-xs sm:text-base "
//         >
//           View all <ArrowRight className="w-3 sm:w-4 h-3 sm:h-4" />
//         </button>
//       </div>
//       {/* Main Content */}
//       <div className="flex flex-col lg:flex-row gap-6">
//         {/* Property Cards */}
//         <div className="flex overflow-x-auto lg:overflow-hidden gap-4 md:gap-6 lg:grid lg:grid-cols-3 flex-1 scroll-smooth snap-x snap-mandatory">
//           {/* Loading Skeleton */}
//           {loading
//             ? Array(3)
//                 .fill(0)
//                 .map((_, i) => (
//                   <div
//                     key={i}
//                     className="bg-white rounded-xl shadow-md border border-gray-100 p-3 flex-shrink-0 w-[80%] md:w-[70%] lg:w-auto snap-start animate-pulse"
//                     data-aos="zoom-in-up"
//                     data-aos-delay={i * 100}
//                   >
//                     <div className="h-52 bg-gray-200 rounded-lg relative"></div>
//                     <div className="mt-4 space-y-2">
//                       <div className="h-5 w-3/4 bg-gray-300 rounded"></div>
//                       <div className="h-4 w-full bg-gray-200 rounded"></div>
//                       <div className="flex justify-between mt-2">
//                         <div className="h-3 w-1/2 bg-gray-300 rounded"></div>
//                         <div className="h-3 w-1/4 bg-gray-300 rounded"></div>
//                       </div>
//                     </div>
//                   </div>
//                 ))
//             : // Actual Property Cards
//               properties.map((property, index) => (
//                 <div
//                   key={property._id}
//                   onClick={() => {
//                     navigate(`/properties/commercial/${property._id}`);
//                     scrollToTop();
//                   }}
//                   className="bg-white rounded-xl shadow-md cursor-pointer flex-shrink-0 w-[80%] md:w-[70%] lg:w-auto snap-start transition-transform hover:scale-[1.02] mb-4 border-2"
//                   data-aos="zoom-in-up"
//                   data-aos-delay={index * 150}
//                 >
//                   <div className="relative overflow-hidden rounded-lg">
//                     <img
//                       src={property.images?.[0]?.url || homeImg}
//                       alt={property.title}
//                       className="w-full h-48 sm:h-60 object-cover transition-transform duration-500 hover:scale-105"
//                     />

//                     <div className="absolute top-3 left-3 bg-green-600 text-white px-2 py-1 rounded-md flex items-center gap-1 text-xs font-semibold">
//                       <CheckCircle className="w-3 h-3" />
//                       <span>Verified</span>
//                     </div>

//                     <div className="absolute bottom-3 right-3 bg-white px-2 py-1 rounded-md shadow-md">
//                       <span className="text-sm font-semibold text-gray-900">
//                         {property?.property?.allowedForConstructionDetails
//                           ?.expectedPrice
//                           ? formatPrice(
//                               property.property.allowedForConstructionDetails
//                                 .expectedPrice
//                             )
//                           : "Price on Request"}
//                       </span>
//                     </div>

//                     <button className="absolute top-3 right-3 bg-white p-2 rounded-full shadow-md">
//                       <Heart className="w-4 h-4 text-gray-600" />
//                     </button>
//                   </div>

//                   <div className="p-4">
//                     <h3 className="font-medium text-[#031722] text-base sm:text-lg md:text-[18px] mb-2">
//                       {truncateText(property.title || "Untitled Property", 18)}
//                     </h3>
//                     <p className="font-normal text-[#6A6A6A] text-sm sm:text-base mb-2 line-clamp-2 h-[2.5rem] sm:h-[3.2rem] md:h-[3.4rem] overflow-hidden">
//                       {property.location?.address?.formatted ||
//                         "Location not specified"}
//                     </p>
//                     <div className="font-normal text-[#797979] text-xs sm:text-sm">
//                       <div>Posted By Owner</div>
//                       <div className="mt-2 flex justify-end">
//                         {timeAgo(
//                           new Date(property.createdAt).toLocaleDateString()
//                         )}
//                       </div>
//                     </div>
//                   </div>
//                 </div>
//               ))}

//           {/* Render Coming Soon cards */}
//           {!loading &&
//             Array.from({ length: comingSoonCount }).map((_, index) =>
//               renderComingSoonCard(index)
//             )}
//         </div>

//         {/* Sidebar Section */}
//         <div className="bg-blue-50 rounded-xl p-6 flex flex-col justify-between text-center lg:w-1/3">
//           <div>
//             <h3 className="text-xl font-semibold text-gray-800 mb-2">
//               Sell faster with trusted buyers
//             </h3>
//             <p className="text-gray-600 text-sm mb-4">
//               Property valuation, premium listings, direct buyers, faster
//               closures. Showcase properties to a wider audience.
//             </p>
//             <div className="flex justify-center">
//               <button className="bg-orange-500 text-white text-sm font-semibold px-5 py-2 rounded-full flex gap-1 hover:bg-orange-600 transition-all">
//                 <img src={propertyLogo} alt="logo" className="w-5 h-5" />
//                 Post Property, For
//                 <span className="font-bold tracking-wider"> FREE!</span>
//               </button>
//             </div>
//           </div>

//           <div className="mt-6">
//             <img src={img} alt="illustration" className="w-full mx-auto" />
//           </div>
//         </div>
//       </div>
//     </div>
//   );
// };

// export default CommercialPropertySection;
